import { c as _c } from "react/compiler-runtime";
import getStarVariant from './helpers/get-star-variant';
import Star from './Star';
const MAX_STARS = 5;
interface Props {
  venueId: string;
  rating?: number | null;
  size?: 'regular' | 'small';
}
const StarRating = t0 => {
  const $ = _c(7);
  const {
    venueId,
    rating: t1,
    size: t2
  } = t0;
  const rating = t1 === undefined ? 0 : t1;
  const size = t2 === undefined ? "regular" : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = Array.from(Array(MAX_STARS));
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const stars = t3;
  const t4 = rating || 0;
  let t5;
  if ($[1] !== t4) {
    t5 = t4.toFixed(2);
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const roundedRating = Number(t5);
  let t6;
  if ($[3] !== roundedRating || $[4] !== size || $[5] !== venueId) {
    t6 = <div className="flex">{stars.map((_, idx) => <Star key={`star-${idx}-${venueId}`} variant={getStarVariant(roundedRating - idx)} size={size} />)}</div>;
    $[3] = roundedRating;
    $[4] = size;
    $[5] = venueId;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
};
export default StarRating;